import styled, { css } from 'styled-components';

import { maxWidth } from '@utils/helpers';

const SPACE_FROM_CENTER = 294;

export const BackgroundCircleWrapper = styled.div(
    () => css`
        left: calc(50% + ${SPACE_FROM_CENTER}px);
        overflow: hidden;
        pointer-events: none;
        position: absolute;
        top: 0;
        transform: translateX(-50%);
        z-index: 0;

        ${maxWidth('md')} {
            left: 50%;
            top: -150px;
        }
    `,
);

export const CircleIconWrapper = styled.div`
    opacity: 0.4;
`;

export const CustomIconWrapper = styled.div`
    left: 50%;
    position: absolute;
    top: calc(50% - 40px);
    transform: translate(-50%, -50%);
`;
